import { mutator } from 'satcheljs';
import { updateFolderPermissionsInStore } from '../actions/publicActions';
import getFolderTable from '../selectors/getFolderTable';
import type { Permission } from 'owa-graph-schema';

/**
 * This function adds missing properties (IsFolderContact) in permission object.
 * @param permissions Array of permissions to sanitize.
 * @returns Array of sanitized permissions.
 */
function sanitizePermissions(permissions: Permission[]): Permission[] {
    return permissions.map(permission => {
        const newPermission: Permission = {
            ...permission,
            ...{
                IsFolderContact: permission.IsFolderContact === true,
            },
        };
        return newPermission;
    });
}

/**
 * Mutator that sets the permissions in folders.
 * @param actionMessage Object containing folderId and permissions
 */
export default mutator(updateFolderPermissionsInStore, actionMessage => {
    const folderId: string = actionMessage.folderId;
    const permissions: Permission[] = sanitizePermissions(actionMessage.permissions);
    const folder = getFolderTable().get(folderId);
    // If folder exists in the folder table, then update permissionSet properties.
    // As folder might be null if user deletes the folder before the getFolderPermission service call comes back.
    if (folder) {
        if (!folder.PermissionSet) {
            folder.PermissionSet = {
                Permissions: permissions,
            };
        } else {
            folder.PermissionSet.Permissions = permissions;
        }
    }
});
